export default "__VITE_ASSET__2xo1FRUJ__"